import { MessageCircle } from "lucide-react";
import { waLink } from "../data/site";
import { track } from "../lib/analytics";

export const WhatsAppFloat = () => (
    <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track("whatsapp_click", { location: "floating_button" })}
        data-testid="whatsapp-float-btn"
        aria-label="Pedir orçamento pelo WhatsApp"
        className="group fixed bottom-5 right-5 z-50 flex items-center gap-3"
    >
        <span className="pointer-events-none hidden sm:block translate-x-2 rounded-full bg-ink px-4 py-2 text-xs font-semibold text-white opacity-0 shadow-xl transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100">
            Orçamento rápido
        </span>
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white shadow-[0_8px_30px_rgba(255,85,0,0.45)] transition-transform duration-300 group-hover:scale-105">
            <span className="absolute inset-0 rounded-full bg-brand animate-pulse-ring" />
            <MessageCircle size={24} className="relative" fill="currentColor" />
        </span>
    </a>
);
